import { z } from "zod";
import { AgencyIdSchema } from "../primitives/ids.js";
export const PortfolioHealthSignalKindSchema = z.enum([
    "OUTSTANDING_ACTION",
    "CLIENT_REQUEST",
    "HEALTH_WARNING",
    "OPPORTUNITY",
]);
export const AgencyPortfolioHealthV1Schema = z
    .object({
    schemaVersion: z.literal("agency-portfolio-health.v1.0"),
    agencyId: AgencyIdSchema,
    items: z.array(z.object({
        projectId: z.string(),
        signalKind: PortfolioHealthSignalKindSchema,
        title: z.string(),
        severity: z.enum(["LOW", "MEDIUM", "HIGH"]),
        updatedAt: z.string().datetime(),
    })),
    generatedAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=care-portfolio-health.js.map